import React, { useEffect, useState } from "react";
import { FaImage } from "react-icons/fa";
import { useLoader } from "../../context/LoaderContext";
import { axiosInstance } from "../../config/https";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

export default function DisputeResolutionComp() {
  const { startLoader, stopLoader } = useLoader();
  const [disputes, setDisputes] = useState([]);

  useEffect(() => {
    const getDisputes = () => {
      startLoader();
      axiosInstance
        .get("/api/disputes/")
        .then((resp) => {
          stopLoader();
          const Data = resp.data;
          if (resp.status === 200 || resp.status === 201) {
            setDisputes(Data.data);
          } else {
            toast.warning(Data.msg);
          }
        })
        .catch(() => {
          stopLoader();
        });
    };
    getDisputes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="dispute-sec pc-p-3">
      <div className="container-fluid px-5">
        <div className="primary-heading color-dark">
          <h3 className="mb-3">Dispute Resolution</h3>
          <h4>Issues</h4>
          {disputes.map((e, i) => (
            <div className="issue-box mt-3" key={i}>
              <h6>
                {e?.title}
                {e?.resolved ? (
                  <span className="tag">Resolved</span>
                ) : (
                  <span className="tag" style={{ backgroundColor: "orange" }}>
                    pending
                  </span>
                )}
              </h6>
              <p>{e?.text}</p>
              <Link to="#">
                Issue <FaImage />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
